import { render, staticRenderFns } from "./productManualDetails.vue?vue&type=template&id=02ef6c7a&scoped=true"
import script from "./productManualDetails.vue?vue&type=script&lang=js"
export * from "./productManualDetails.vue?vue&type=script&lang=js"
import style0 from "./productManualDetails.vue?vue&type=style&index=0&id=02ef6c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ef6c7a",
  null
  
)

export default component.exports